import { Dialog } from '@headlessui/react'
import { useNavigate } from 'react-router-dom'

import ClockIcon from '@Icons/clock-fast-forward.svg?react'
import XIcon from '@Icons/x-close-filter.svg?react'
import PrimaryButton from '@Utils/buttons/primary-button'
import { useAlreadyReportedUrlDispatch } from '@Utils/context/modal/UseAlreadyReportedUrl'

function AlreadyReportedModal(): JSX.Element {
  const { close } = useAlreadyReportedUrlDispatch()

  const navigate = useNavigate()

  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{
        background: 'rgba(41, 41, 41, 0.7)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <Dialog.Panel className="relative border rounded-xl shadow-xl bg-white-100 ">
        <div className="flex flex-col p-6 ">
          <button
            className="absolute right-8 active:bg-gray-50 border-0 p-2 rounded-full"
            onClick={close}
          >
            <XIcon />
          </button>
          <div className="flex flex-col   w-96">
            <div className="flex justify-center w-full">
              <ClockIcon />
            </div>

            <Dialog.Title className="text-lg font-medium text-gray-900 mt-4 mb-2 flex justify-center">
              URL Already Reported
            </Dialog.Title>
            <Dialog.Description className="text-sm font-normal text-gray-700 mt-2 mb-4 flex">
              <div>
                You've already reported this website. In general, a problem
                affects all the URLs, so that reporting just one URL is enough.
                We'll take care of all the URLs in your panel. You can always
                check the status of your reports on your{' '}
                <a href="https://app.prisync.com/open-reports">
                  <u>support page</u>
                </a>
                .
              </div>
            </Dialog.Description>
            <div className="flex justify-center gap-3 mt-8">
              <button
                onClick={() => navigate('/open-reports')}
                className="underline w-full"
              >
                URL Dashboard
              </button>
              <PrimaryButton
                bgColor="600"
                type="submit"
                classNameText="px-4 w-full"
                classNameButton="h-11 w-full"
                onClick={close}
              >
                OK
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Dialog.Panel>
    </div>
  )
}

export default AlreadyReportedModal
